import Vue from 'vue'
import u from '@/util'
import {
  t
} from '@/i18n'
import dal from '@/data'
import {
  error
} from '@/store'

const state = {
  items: [],
  item: {
    role: 'G'
  },
  activeTab: 0,
  editing: false,
  spliting: false,
  dirty: false,
  valid: true,
  rules: {
    required: v => state.editing && (!!v || t('Required')),
    start: v => !v || !state.item.end || v <= state.item.end || t('End > start'),
    end: v => !v || !state.item.start || state.item.start <= v || t('End > start')
  }
}

const filter = (item, d) => u.periodsOverlap(item.start, item.end, d, d)

const getters = {
  itemsByDate: state => d => state.items.filter(a => filter(a, d)),
  itemsBefore: state => d => state.items.filter(a => !filter(a, d)),
  activeItems: (state, getters) => {
    return ('' + state.activeTab === '0' ?
        getters.itemsByDate(u.today()) :
        getters.itemsBefore(u.today()))
      .sort(u.comparator('person'))
  },
  person: state => state.item && state.item.person || '',
  role: state => state.item && state.item.role || 'G',
  start: state => state.item && state.item.start,
  end: state => state.item && state.item.end,
  endHint: (state, _1, _2, rootGetters) => getters.end === rootGetters['meeting/lastDate'] ? t('Last meeting date') : t(''),
  isNew: (state, _1, _2, rootGetters) => !rootGetters.hasKey(state.item),
  // roleDisabled: (state, getters) => !getters.isNew && state.item.start === u.today(),
  props: (state, getters, rootGetters) => ({
    add: {
      disabled: false,
      show: true
    },
    finish: {
      disabled: getters.isNew || state.dirty,
      show: state.editing
    },
    remove: {
      disabled: getters.isNew || state.dirty,
      show: state.editing
    },
    save: {
      disabled: !state.dirty,
      show: state.editing
    },
    split: {
      disabled: state.dirty || state.spliting,
      show: !state.editing
    }
  })
}

const mutations = {
  item(state, item) {
    const v = item || {}
    state.item = state.item || {}
    state.oldItem = state.oldItem || {}
    Object.keys(v).forEach(k => Vue.set(state.item, k, v[k]))
    Object.keys(v).forEach(k => Vue.set(state.oldItem, k, v[k]))
    state.editing = !!item
  },
  person(state, person) {
    Vue.set(state.item, 'person', person.trim())
  },
  role(state, role) {
    Vue.set(state.item, 'role', role)
  },
  start(state, date) {
    Vue.set(state.item, 'start', date)
  },
  end(state, date) {
    Vue.set(state.item, 'end', date)
  },
  dirty(state, flag) {
    state.dirty = flag
  },
  valid(state, flag) {
    state.valid = flag
  },
  activeTab(state, index) {
    state.activeTab = index
  },
  edit(state, item) {
    state.oldItem = {
      ...(item || {})
    }
    state.item = {
      ...(item || {})
    }
    state.editing = true
  },
  editing(state, flag) {
    state.editing = flag
    if (flag === false) {
      state.item = {}
      state.dirty = false
    }
  },
  spliting(state, flag) {
    state.spliting = flag
  }
}

const actions = {
  bind: dal.assignments.bindAssignment('items'),
  unbind: dal.assignments.unbindAssignment('items'),

  async back(context) {
    if (context.rootGetters.readOnly || await actions['pass dirty?'](context)) {
      context.commit('editing', false)
      context.commit('spliting', false)
    }
  },

  add(context, start) {
    if (context.rootGetters.readOnly) return
    start = start || u.dateAdd(context.rootGetters['meeting/lastDate'] || '2017-12-31', 1)
    return context.commit('item', {
      cell: context.rootGetters.cell,
      start,
      role: 'G'
    })
  },

  /** Only save new, no updates */
  async save(context, item) {
    if (context.rootGetters.readOnly) return
    const askEnd = !item
    item = item || context.state.item
    const valid = await context.dispatch('valid', {
      module: 'assignment'
    }, {
      root: true
    })
    if (!valid) return
    try {
      const lastMeetingDate = context.rootGetters['meeting/lastDate']
      if (context.state.oldItem.start !== item.start && lastMeetingDate && lastMeetingDate >= item.start) {
        context.commit('error', u.error('Start date must after last meeting', lastMeetingDate), {
          root: true
        })
        return
      }
      if (askEnd && context.state.oldItem.end !== item.end) {
        await context.dispatch('changeEnd')
        return
      }
      await dal.assignments.save(item)
      context.commit('editing', false)
      context.commit('snackbar', t('Saved'), {
        root: true
      })
    } catch (e) {
      error(context)(e)
    }
  },

  async changeEnd(context, payload) {
    if (payload) {
      const item = {
        ...context.rootGetters['meeting/attendance'][payload.index],
        end: u.dateAdd(payload.date, -1)
      }
      context.commit('item', item)
    }
    if (context.rootGetters.readOnly) return
    const {
      end
    } = context.state.item
    const lastMeetingDate = context.rootGetters['meeting/lastDate']
    if (end < lastMeetingDate) {
      const dialog = {
        content: 'Assignment end < last meeting',
        params: lastMeetingDate
      }
      if (await context.dispatch('confirm', dialog, {
          root: true
        })) {
        context.commit('end', lastMeetingDate)
        await dal.assignments.end(context.state.item)
        context.commit('editing', false)
      }
    } else {
      const dialog = {
        content: 'Change the end of assignment?',
        params: end
      }
      if (await context.dispatch('confirm', dialog, {
          root: true
        })) {
        console.log('dal.assignments.end', context.state.item)
        await dal.assignments.end(context.state.item)
        context.commit('editing', false)
      }
    }
  },

  async changeRole(context) {
    if (context.getters.isNew || context.rootGetters.readOnly) return
    const valid = await context.dispatch('valid', {
      module: 'assignment'
    }, {
      root: true
    })
    if (!valid) return

    const today = u.today()
    const yesterday = u.dateAdd(today, -1)
    // if (context.state.item.start === today) {
    //   context.commit('error', u.error('Cannot change role twice a day'), { root: true })
    //   actions.revert(context)
    //   return
    // }

    const dialog = {
      content: 'Change role',
      params: {
        oldRole: context.rootGetters.roleName(context.state.oldItem.role),
        to: yesterday,
        newRole: context.rootGetters.roleName(context.state.item.role),
        from: today,
        person: context.state.item.person
      }
    }
    if (context.state.oldItem.start >= today) {
      dialog.params.from = dialog.params.to = context.state.oldItem.start
      if (await context.dispatch('confirm', dialog, {
          root: true
        })) {
        context.dispatch('save')
      }
    } else if (await context.dispatch('confirm', dialog, {
        root: true
      })) {
      // context.commit('item', { ...context.state.item, start: today })
      const item1 = {
        ...context.state.oldItem,
        end: yesterday
      }
      const item2 = {
        ...context.state.item,
        start: today
      }
      item2['.key'] = null
      context.dispatch('save', item1).then(() =>
        context.dispatch('save', item2))
    } else {
      actions.revert(context)
    }
  },

  async changeName(context) {
    if (context.getters.isNew || context.rootGetters.readOnly) return
    const valid = await context.dispatch('valid', {
      module: 'assignment'
    }, {
      root: true
    })
    if (!valid) return

    const oldName = context.state.oldItem.person
    const newName = context.state.item.person
    const dialog = {
      content: 'Change name',
      params: {
        oldName,
        newName
      }
    }
    if (await context.dispatch('confirm', dialog, {
        root: true
      })) {
      const key = context.state.item['.key']
      const cell = context.rootState.auth.cell
      const dates = context.rootState.meeting.dates
      await dal.assignments.changeName(oldName, newName, key, cell, dates)
      context.commit('editing', false)
    } else {
      actions.revert(context)
    }
  },

  // async askSetEnd (context) {
  //   if (context.rootGetters.readOnly) return
  //   const { end } = context.state.item
  //   const lastMeetingDate = context.rootGetters['meeting/lastDate']
  //   const dialog = { content: 'Set the end on the last meeting?', params: lastMeetingDate }
  //   if (!end && lastMeetingDate && await context.dispatch('confirm', dialog, { root: true })) {
  //     context.commit('end', lastMeetingDate)
  //     context.commit('dirty', true)
  //   }
  // },

  async finish(context) {
    if (context.rootGetters.readOnly) return
    // const today = u.today()
    const lastMeetingDate = context.rootGetters['meeting/lastDate']
    // if (lastMeetingDate >= today) {
    //   const dialog = { content: 'Assignment end < last meeting', params: lastMeetingDate }
    //   if (await context.dispatch('confirm', dialog, { root: true })) {} else return
    // } else {
    //   const dialog = { content: 'End assignment?', params: 'this assignment' }
    //   if (await context.dispatch('confirm', dialog, { root: true })) {} else return
    // }
    const end = lastMeetingDate < context.state.item.start ? context.state.item.start : lastMeetingDate
    const item = {
      ...context.state.item,
      end
    }
    context.commit('item', item)
    context.commit('dirty', true)
    // await dal.assignments.end(item)
    // context.commit('editing', false)
  },

  /** Removes the item stored in state.item */
  async remove(context) {
    if (context.rootGetters.readOnly) return
    const lastMeetingDate = context.rootGetters['meeting/lastDate']
    if (lastMeetingDate >= context.state.item.start) {
      context.commit('error', u.error('Assignment used in meetings', lastMeetingDate), {
        root: true
      })
      return
    }

    const params = {
      params: t('this assignment', context.state.item)
    }
    if (await context.dispatch('confirmDelete', params, {
        root: true
      })) {
      await dal.assignments.remove(context.state.item)
      context.commit('editing', false)
      context.commit('snackbar', t('Removed'), {
        root: true
      })
    }
  },

  async split(context) {
    context.commit('spliting', true)
  },

  async beforeRouteLeave(context, {
    to,
    from,
    next
  }) {
    if (context.rootGetters.readOnly) {
      next()
    } else if (await actions['pass dirty?'](context)) {
      next()
    } else {
      next(false)
    }
  },

  revert(context) {
    context.commit('item', context.state.oldItem)
    context.commit('dirty', false)
  },

  'pass dirty?': function (context, payload) {
    if (context.rootGetters.readOnly) return 'no'
    return context.dispatch('dirty', {
      dirty: context.state.dirty,
      module: 'assignment',
      caller: actions,
      saver: () => {
        actions.save(context, payload || {})
      }
    }, {
      root: true
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
